import { styled } from '@linaria/react';
import { AppShell } from '@mantine/core';
import { ReactNode, useContext } from 'react';
import { User } from '../../components/user/user';
import { UserContext } from '../../contexts/user';
import { isString } from '../../helpers/string-helpers/string-helpers';
import { BREAKPOINTS } from '../../styles/breakpoints';
import { secondaryBase, skyLighter } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';
import { H2 } from '../../ui-library/typography/typography';
import { FloraButton } from '../flora/flora-button';
import { appConfig } from '../../helpers/app-config/app-config';

type Props = {
  header?: string | ReactNode;
  actions?: ReactNode;
  hideFloraAside?: boolean;
};

export function HeaderBar({ header, actions, hideFloraAside }: Props) {
  const { user } = useContext(UserContext);
  const headerComponent = isString(header) ? <H2>{header}</H2> : header;

  return (
    <AppShell.Header style={{ backgroundColor: skyLighter, zIndex: 400 }}>
      <Container style={{ justifyContent: header ? 'space-between' : 'flex-end', gap: 8 }}>
        {headerComponent}
        <ProfileContainer>
          {actions}
          {!hideFloraAside && <FloraButton />}
          <Icon
            name="help_outline"
            color={secondaryBase}
            size={28}
            onClick={() => {
              const helpUrl = appConfig.VITE_APP_HELP_URL;
              if (helpUrl) {
                window.open(helpUrl, '_blank', 'noopener,noreferrer');
              } else {
                console.error('VITE_APP_HELP_URL environment variable is not configured');
              }
            }}
            data-bf="header-btn-help"
          />
          <User user={user} />
        </ProfileContainer>
      </Container>
    </AppShell.Header>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  min-height: 60px;
  box-sizing: border-box;
  padding: 8px 16px 0px 16px;

  @media (max-width: ${BREAKPOINTS.xl}) {
    align-items: flex-start;
    padding-top: 12px;
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1em;
`;
